export enum PlanTypes {
  _UPDATE_PLAN_FORM = 'UPDATE_PLAN_FORM',
  _CLEAR_PLAN_FORM = 'CLEAR_PLAN_FORM',

  UPDATE_PLAN_FORM_CALL = 'UPDATE_PLAN_FORM_CALL',
  CLEAR_PLAN_FORM_CALL = 'CLEAR_PLAN_FORM_CALL',
  UPDATE_PAYMENT_FORM = 'UPDATE_PAYMENT_FORM',
  CLEAR_PAYMENT_FORM = 'CLEAR_PAYMENT_FORM',
  _CREATE_PLAN = '_CREATE_PLAN',
  CREATE_PLAN_CALL = 'CREATE_PLAN_CALL',

  VALIDATE_PLAN_NAME_CALL = 'VALIDATE_PLAN_NAME_CALL',

  GET_USER_PLANS_CALL = 'GET_USER_PLANS_CALL',
  GET_USER_PLANS_REQUEST = 'GET_USER_PLANS_REQUEST',
  _UPDATE_ALL_PLANS = '_UPDATE_ALL_PLANS',

  GET_USER_PLAN_BY_ID = 'GET_USER_PLAN_BY_ID',
  GET_USER_PLAN_BY_ID_REQUEST = ' GET_USER_PLAN_BY_ID_REQUEST',

  FUND_PLAN_REQUEST = 'FUND_PLAN_REQUEST',
  FUND_PLAN_REQUEST_SUCCESS = 'FUND_PLAN_REQUEST_SUCCESS',
  FUND_PLAN_REQUEST_FAILURE = 'FUND_PLAN_REQUEST_FAILURE',

  TOP_UP_PLAN_REQUEST = 'TOP_UP_PLAN_REQUEST',
  TOP_UP_PLAN_REQUEST_SUCCESS = 'TOP_UP_PLAN_REQUEST_SUCCESS',

  CREATE_PLAN_REQUEST = 'CREATE_PLAN_REQUEST',
  CREATE_PLAN_REQUEST_SUCCESS = 'CREATE_PLAN_REQUEST_SUCCESS',
  CREATE_PLAN_REQUEST_FAILURE = 'CREATE_PLAN_REQUEST_FAILURE',

  UPDATE_PLAN_REQUEST = 'UPDATE_PLAN_REQUEST',
  UPDATE_PLAN_REQUEST_SUCCESS = 'UPDATE_PLAN_REQUEST_SUCCESS',
  UPDATE_PLAN_REQUEST_FAILURE = 'UPDATE_PLAN_REQUEST_FAILURE',

  DELETE_PLAN_REQUEST = 'DELETE_PLAN_REQUEST',
  DELETE_PLAN_REQUEST_SUCCESS = 'DELETE_PLAN_REQUEST_SUCCESS',
  DELETE_PLAN_REQUEST_FAILURE = 'DELETE_PLAN_REQUEST_FAILURE',

  HAS_SEEN_PLAN_INFO = 'HAS_SEEN_PLAN_INFO',
  HAS_SEEN_PLAN_INFO_SUCCESS = 'HAS_SEEN_PLAN_INFO_SUCCESS',
}

export interface PlanState {
  plans: Plan[]
  planForm: CreateManualPlan | CreateAutomatedPlan | null
  plansInfo: {
    readEmergency: boolean
  }
}

export type TPlan = 'target' | 'general' | 'emergency' | 'contest' | 'collabo'

//interface for collabo plan type
export type PPlan = TPlan | 'collabo' | 'contest'

export type TSavingType = 'automated' | 'manual'
export type TFrequency = 'daily' | 'weekly' | 'monthly'
export type TDevice = 'mobile'

export interface Plan {
  id: string
  name: string
  wants_interest?: boolean
  main_card: string
  fallback_card?: string
  saving_type: TSavingType
  saving_frequency: TFrequency
  start_date?: Date
  amount_to_save?: number
  balance: string
  accrued_interest?: number
  next_saving_date?: Date
  maturity_date: Date
  progress?: string
  plan_type: TPlan
  can_withdraw?: boolean
  progress_percent: number
  saving_date_time?: string
}

//used only on portfolio
export interface PortfolioPlan extends Omit<Plan, 'plan_type'> {
  plan_type: PPlan
}

export interface CreatePlan {
  plan_name?: string
  plan_type?: TPlan
  saving_type: TSavingType
  device: TDevice
  start_date: string
  amount_to_save: number
  maturity_date: string
  id?: string
  timeline?: string
  saving_date_time?: string
}

export interface CreateAutomatedPlan extends CreatePlan {
  main_card: 'new' | string
  saving_frequency: TFrequency
}

export interface CreateManualPlan extends CreatePlan {}
